import { PermissionEnum } from '../../user-roles/types';

const replaceMap: Record<string, string> = {
  'Aml Kyc': 'AML & KYC',
  'Blacklists List': 'Blocklists List',
  'Blacklists Items List': 'Blocklists Items List',
  'Users Device Sessions List': 'Profile Device Sessions List',
  Psp: 'Banks',
  'Exchange Settings': 'Exchange',
  'Fee Tariffs': 'Fees & Tariffs',
  'Psp List': 'Banks List',
  'Settings Factors': 'Edit',
  'Documents Create': 'Documents Create',
  'Documents Delete': 'Documents Delete',
  'Psp Integration Account List': 'External Accounts List',
  'Psp Integration Account': 'External Account',
  'Psp Integration Account Add Action': 'Create',
  'Psp Integration Account Edit Action': 'Edit',
  'Warnings List': 'Warnings reports',
  'Warnings Download Action': 'Export',
  'Psp Documents List': 'Bank Documents List',
  'Psp Account Documents List': 'Bank Account Documents List',
  'Psp Integration Logs List': 'Bank Integration Logs List',
  'Psp Integration Logs List By Psp Partner':
    'Bank Integration Logs List By Bank Partner',
};

const getPreparePermissions = (
  data: {
    key: PermissionEnum;
    pages?: {
      key: PermissionEnum;
      actions?: {
        key: PermissionEnum;
      }[];
    }[];
  }[],
) => {
  const map: Partial<
    Record<
      string,
      {
        title: string;
        pagesKeys: PermissionEnum[] | [];
        pages?: Partial<
          Record<
            string,
            {
              title: string;
              sectionKey: PermissionEnum;
              actionsKeys: PermissionEnum[] | [];
              actions?: Partial<
                Record<
                  string,
                  {
                    title: string;
                    description: string;
                    sectionKey: PermissionEnum;
                    pageKey: PermissionEnum;
                  }
                >
              >;
            }
          >
        >;
      }
    >
  > = {};

  data.map((section) => {
    let sectionsKeyArray = PermissionEnum[section.key]?.split('_');

    if (!PermissionEnum[section.key]) {
      sectionsKeyArray = section.key.split('_');
    }

    let sectionTitle = sectionsKeyArray
      ?.splice(1)
      ?.map((item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`)
      ?.join(' ');

    if (replaceMap[sectionTitle]) {
      sectionTitle = replaceMap[sectionTitle];
    }

    map[section.key] = {
      title: sectionTitle,
      pagesKeys: [],
    };

    if (section.pages?.length) {
      section.pages.map((page) => {
        if (map[section.key]?.pages === undefined) {
          map[section.key]!.pages = {};
        }
        let pagesKeyArray = PermissionEnum[page.key]?.split('_');

        if (!PermissionEnum[page.key]) {
          pagesKeyArray = page?.key?.split('_');
        }

        let pageTitle = pagesKeyArray
          ?.map((item) => {
            const result = `${item.charAt(0)}${item.slice(1).toLowerCase()}`;

            return result;
          })
          ?.join(' ');

        if (replaceMap[pageTitle]) {
          pageTitle = replaceMap[pageTitle];
        }

        map[section.key]!.pages![page.key] = {
          title: pageTitle,
          sectionKey: section.key,
          actionsKeys: [],
        };

        map[section.key]!.pagesKeys = [
          ...map[section.key]!.pagesKeys,
          page.key,
        ];

        if (page.actions?.length) {
          page.actions.map((action) => {
            if (map[section.key]!.pages![page.key]!.actions === undefined) {
              map[section.key]!.pages![page.key]!.actions = {};
            }

            let actionsKeyArray = PermissionEnum[action.key]?.split('_');

            if (!PermissionEnum[action.key]) {
              actionsKeyArray = action.key.split('_');
            }

            const actionTitle = actionsKeyArray
              ?.map((item) => {
                const result = `${item.charAt(0)}${item
                  .slice(1)
                  .toLowerCase()}`;

                return result;
              })
              ?.join(' ');

            let actionTitleResult = actionTitle;

            Object.keys(replaceMap).forEach((key) => {
              if (actionTitle.includes(key)) {
                actionTitleResult = actionTitle.replace(key, replaceMap[key]);
              }
            });

            actionTitleResult = actionTitleResult.replace('Action', '');

            pagesKeyArray.forEach((item) => {
              if (
                actionTitleResult.toLowerCase().includes(item.toLowerCase())
              ) {
                if (
                  action.key !==
                  PermissionEnum.COFF_CUSTOMERS_CONVERT_TO_INDIVIDUAL_ACTION
                ) {
                  actionTitleResult = actionTitleResult.replace(
                    `${item.charAt(0)}${item.slice(1).toLowerCase()}`,
                    '',
                  );
                } else if (
                  action.key ===
                  PermissionEnum.COFF_CUSTOMERS_CONVERT_TO_INDIVIDUAL_ACTION
                ) {
                  actionTitleResult = actionTitleResult.replace('Coff', 'COF');
                }
              }
            });

            map[section.key]!.pages![page.key]!.actions![action.key] = {
              title: actionTitleResult,
              description: map[section.key]!.pages![page.key]?.title || '',
              sectionKey: section.key,
              pageKey: page.key,
            };

            map[section.key]!.pages![page.key]!.actionsKeys = [
              ...map[section.key]!.pages![page.key]!.actionsKeys,
              action.key,
            ];

            return null;
          });
        }
        return null;
      });
    }
    return null;
  });
  return map;
};

export default getPreparePermissions;
